import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentoringDocumentModel } from 'common/models/page-models/mentoring-document/mentoring-document-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentoringFormWidgetService } from 'common/widget/mentoring-doc/mentoring-form.widget.service';

@Injectable({
    providedIn: 'root'
})
export class MentoringDocumentFormResolver extends FormResolverService<MentoringDocumentModel> {
    constructor(
        protected fs: MentoringFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
